import React from 'react';
import { Card } from '../ui';
import { typography } from '../../styles/typography';
import { ArrowRight, Calendar, Clock } from 'lucide-react';

const RideScheduleCard = ({ ride, onClick, formatTimestamp }) => {
  return (
    <Card.Gradient
      className="p-6 cursor-pointer hover:shadow-lg transition-shadow"
      onClick={onClick}
    >
      <div className="flex flex-col gap-4">
        {/* From and To Sites */}
        
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-sm font-semibold text-gray-600">From:</span>
              <span className={typography.h5} style={{ color: '#000000' }}>
                {ride.fromSiteName || 'Unknown'}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-gray-600">To:</span>
              <span className={typography.h5} style={{ color: '#000000' }}>
                {ride.toSiteName || 'Unknown'}
              </span>
            </div>
          </div>
          
          {/* <ArrowRight className="w-6 h-6 text-gray-600 flex-shrink-0" /> */}
        

        {/* Ride ID */}
        {/* <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-gray-600">Ride ID:</span>
          <span className="text-sm text-gray-800 font-mono">{ride.ride_id}</span>
        </div> */}

        {/* Timestamps */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="flex items-start gap-2">
            <Calendar className="w-5 h-5 text-gray-600 mt-0.5 flex-shrink-0" />
            <div>
              <div className="text-sm font-semibold text-gray-600 mb-1">Start Time</div>
              <div className={typography.body1} style={{ color: '#000000' }}>
                {formatTimestamp(ride.ride_start_timestamp)}
              </div>
            </div>
          </div>
          <div className="flex items-start gap-2">
            <Clock className="w-5 h-5 text-gray-600 mt-0.5 flex-shrink-0" />
            <div>
              <div className="text-sm font-semibold text-gray-600 mb-1">End Time</div>
              <div className={typography.body1} style={{ color: '#000000' }}>
                {formatTimestamp(ride.ride_end_timestamp)}
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        {/* <div className="flex items-center gap-4 mt-2 pt-2 border-t border-gray-200">
          <div className="text-sm">
            <span className="font-semibold text-gray-600">Activity By: </span>
            <span className="text-gray-800">{ride.activity_done_by || 'N/A'}</span>
          </div>
          {ride.alert_sent !== undefined && (
            <div className="text-sm">
              <span className="font-semibold text-gray-600">Alert: </span>
              <span className={ride.alert_sent ? 'text-green-600' : 'text-gray-600'}>
                {ride.alert_sent ? 'Sent' : 'Not Sent'}
              </span>
            </div>
          )}
        </div> */}
      </div>
    </Card.Gradient>
  );
};

export default RideScheduleCard;

